
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.3335 0.5685C3.3335 0.254523 3.58883 0 3.9038 0H16.0965C16.4115 0 16.6668 0.254523 16.6668 0.5685V16.7028C16.6668 17.0167 16.4115 17.2713 16.0965 17.2713H14.2189C13.9039 17.2713 13.6486 17.0167 13.6486 16.7028C13.6486 16.3887 13.9039 16.1343 14.2189 16.1343H15.5262V1.137H6.78862L10.7738 2.77155C10.9876 2.85923 11.1271 3.06687 11.1271 3.29729V19.4315C11.1271 19.6211 11.0323 19.7983 10.8742 19.9039C10.7161 20.0094 10.5157 20.0294 10.3398 19.9572L3.68679 17.2284C3.47303 17.1408 3.3335 16.9331 3.3335 16.7028V0.5685ZM4.4741 1.41715V16.3219L9.98649 18.5829V3.67812L4.4741 1.41715ZM7.26381 10.4767C7.42908 10.2094 7.78042 10.1264 8.04853 10.2911L8.05065 10.2924C8.31877 10.4572 8.40214 10.8074 8.23687 11.0746C8.0716 11.3419 7.72026 11.425 7.45214 11.2603L7.45003 11.259C7.18191 11.0943 7.09854 10.744 7.26381 10.4767Z","fill":"#A1AAC6"}})])
          )
        }
      }
    